import React from 'react'
import classes from './Interpretation.css'
import FormattedDate from '../../components/FormattedDate'
import {
  checkHideQTCorrectionType,
} from 'configs'

export const Interpretation = props => {
  const {
    date, fetching, interpretationTitle, note, reviewer, severityClass, me, isServiceProviderEnabled, qtAnalysisData, interpretation, isQTEnabled,
  } = props
  const qtValues = (isServiceProviderEnabled || isQTEnabled) && qtAnalysisData && qtAnalysisData.qt && qtAnalysisData.qt.find(qt => qt.interpretationID === interpretation.id)
  const kpspTeamName = interpretation && interpretation.member && interpretation.member.teamName
  const hideQTCorrectionType = me && checkHideQTCorrectionType(me)
  return (
    <div className={`${classes.interpretation} ${classes[severityClass]}`}>
      <div className={classes.reviewer}>{reviewer} {isServiceProviderEnabled && kpspTeamName && `from ${kpspTeamName}`} </div>

      <div className={classes.date}>
        <FormattedDate date={date} me={me} />
      </div>
      {(isServiceProviderEnabled || isQTEnabled) && (qtValues) &&
        <div className={classes.qtValueCss} >
          QTcf: {qtValues.qtcf}, QT: {qtValues.qt}, {hideQTCorrectionType ? 'QTc:' : 'QTcb:'} {qtValues.qtcb}, RR: {qtValues.rr}
        </div>
      }

      <div>
        <h1 className={classes.interpretationTitle}>{interpretationTitle !== 'NOINTERPRETATION' && interpretationTitle}</h1>
      </div>

      <div className={classes.note}>{note}</div>
    </div>
  )
}

export default Interpretation



// WEBPACK FOOTER //
// ./src/legacy/components/Interpretation/Interpretation.jsx